import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  templateUrl: './sidenav-dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SidenavDashboardComponent {}
